import { ComponentType } from 'react';
import dynamic from 'next/dynamic';
import { ScreenType } from 'core/flow/entities';

interface ScreenComponentDefinition {
  Screen: ComponentType<{ id: string }>;
  importChunk: () => Promise<unknown>;
}

export const screenComponents: Partial<Record<ScreenType, ScreenComponentDefinition>> = {
  [ScreenType.TIME_V2]: {
    Screen: dynamic(() => import('./TimeV2').then((mod) => mod.default)),
    importChunk: () => import('./TimeV2'),
  },
  [ScreenType.DATE_PICKER_V2]: {
    Screen: dynamic(() => import('./DatePickerV2').then((mod) => mod.default)),
    importChunk: () => import('./DatePickerV2'),
  },
  [ScreenType.GENDER]: {
    Screen: dynamic(() => import('./Gender').then((mod) => mod.Gender)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.GENDER_PALMISTRY]: {
    Screen: dynamic(() => import('./GenderPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./GenderPalmistry'),
  },
  [ScreenType.GENDER_MOON_COMPATIBILITY]: {
    Screen: dynamic(() => import('./GenderMoonCompatibility').then((mod) => mod.default)),
    importChunk: () => import('./GenderMoonCompatibility'),
  },
  [ScreenType.PRELANDING_MOON_COMPATIBILITY]: {
    Screen: dynamic(() => import('./PrelandingMoonCompatibility').then((mod) => mod.default)),
    importChunk: () => import('./PrelandingMoonCompatibility'),
  },
  [ScreenType.PRELANDING_PALMISTRY]: {
    Screen: dynamic(() => import('./PrelandingPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./PrelandingPalmistry'),
  },
  [ScreenType.GOAL]: {
    Screen: dynamic(() => import('./Goal').then((mod) => mod.default)),
    importChunk: () => import('./Goal'),
  },
  [ScreenType.GOAL_SET]: {
    Screen: dynamic(() => import('./GoalSet').then((mod) => mod.default)),
    importChunk: () => import('./GoalSet'),
  },
  [ScreenType.INFORMATIONAL]: {
    Screen: dynamic(() => import('./Informational').then((mod) => mod.default)),
    importChunk: () => import('./Informational'),
  },
  [ScreenType.INFORMATIONAL_PALMISTRY]: {
    Screen: dynamic(() => import('./InformationalPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./InformationalPalmistry'),
  },
  [ScreenType.INFORMATIONAL_NATAL_CHART]: {
    Screen: dynamic(() => import('./InformationalNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./InformationalNatalChart'),
  },
  [ScreenType.IMAGE_INFORMATIONAL]: {
    Screen: dynamic(() => import('./ImageInformational').then((mod) => mod.default)),
    importChunk: () => import('./ImageInformational'),
  },
  [ScreenType.DATE]: {
    Screen: dynamic(() => import('./Date').then((mod) => mod.default)),
    importChunk: () => import('./Date'),
  },
  [ScreenType.DATE_PALMISTRY]: {
    Screen: dynamic(() => import('./DatePalmistry').then((mod) => mod.default)),
    importChunk: () => import('./DatePalmistry'),
  },
  [ScreenType.DATE_NATAL_CHART]: {
    Screen: dynamic(() => import('./DateNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./DateNatalChart'),
  },
  [ScreenType.DATE_NATAL_CHART_V2]: {
    Screen: dynamic(() => import('./DateNatalChartV2').then((mod) => mod.default)),
    importChunk: () => import('./DateNatalChartV2'),
  },
  [ScreenType.TIME]: {
    Screen: dynamic(() => import('./Time').then((mod) => mod.default)),
    importChunk: () => import('./Time'),
  },
  [ScreenType.TIME_NATAL_CHART]: {
    Screen: dynamic(() => import('./TimeNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./TimeNatalChart'),
  },
  [ScreenType.PLACE]: {
    Screen: dynamic(() => import('./Place').then((mod) => mod.default)),
    importChunk: () => import('./Place'),
  },
  [ScreenType.PLACE_NATAL_CHART]: {
    Screen: dynamic(() => import('./PlaceNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./PlaceNatalChart'),
  },
  [ScreenType.NAME]: {
    Screen: dynamic(() => import('./Name').then((mod) => mod.default)),
    importChunk: () => import('./Name'),
  },
  [ScreenType.ANSWER]: {
    Screen: dynamic(() => import('./Answer').then((mod) => mod.default)),
    importChunk: () => import('./Answer'),
  },
  [ScreenType.ANSWER_EMOJI]: {
    Screen: dynamic(() => import('./AnswerEmoji').then((mod) => mod.default)),
    importChunk: () => import('./AnswerEmoji'),
  },
  [ScreenType.DYNAMIC_ANSWER]: {
    Screen: dynamic(() => import('./DynamicAnswer').then((mod) => mod.default)),
    importChunk: () => import('./DynamicAnswer'),
  },
  [ScreenType.DYNAMIC_ANSWER_V2]: {
    Screen: dynamic(() => import('./DynamicAnswerV2').then((mod) => mod.default)),
    importChunk: () => import('./DynamicAnswerV2'),
  },
  [ScreenType.ANSWER_PALMISTRY]: {
    Screen: dynamic(() => import('./AnswerPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./AnswerPalmistry'),
  },
  [ScreenType.ANSWER_NATAL_CHART]: {
    Screen: dynamic(() => import('./AnswerNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./AnswerNatalChart'),
  },
  [ScreenType.ANSWER_NATAL_CHART_V2]: {
    Screen: dynamic(() => import('./AnswerNatalChartV2').then((mod) => mod.default)),
    importChunk: () => import('./AnswerNatalChartV2'),
  },
  [ScreenType.ANSWER_HORIZONTAL_ORIENTATION]: {
    Screen: dynamic(() => import('./AnswerHorizontalOrientaion').then((mod) => mod.default)),
    importChunk: () => import('./AnswerHorizontalOrientaion'),
  },
  [ScreenType.ANSWER_HORIZONTAL_ORIENTATION_V2]: {
    Screen: dynamic(() => import('./AnswerHorizontalOrientationV2').then((mod) => mod.default)),
    importChunk: () => import('./AnswerHorizontalOrientationV2'),
  },
  [ScreenType.MULTIPLE_ANSWERS]: {
    Screen: dynamic(() => import('./MultipleAnswers').then((mod) => mod.default)),
    importChunk: () => import('./MultipleAnswers'),
  },
  [ScreenType.MULTIPLE_ANSWERS_V2]: {
    Screen: dynamic(() => import('./MultipleAnswersV2').then((mod) => mod.MultipleAnswersV2)),
    importChunk: () => import('./MultipleAnswersV2'),
  },
  [ScreenType.MULTIPLE_ANSWERS_NATAL_CHART]: {
    Screen: dynamic(() => import('./MultipleAnswersNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./MultipleAnswersNatalChart'),
  },
  [ScreenType.MULTIPLE_ANSWERS_NATAL_CHART_V2]: {
    Screen: dynamic(() => import('./MultipleAnswersNatalChartV2').then((mod) => mod.default)),
    importChunk: () => import('./MultipleAnswersNatalChartV2'),
  },
  [ScreenType.PROCESSING]: {
    Screen: dynamic(() => import('./Processing').then((mod) => mod.default)),
    importChunk: () => import('./Processing'),
  },
  [ScreenType.PROCESSING_PALMISTRY]: {
    Screen: dynamic(() => import('./ProcessingPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./ProcessingPalmistry'),
  },
  [ScreenType.PROCESSING_NATAL_CHART]: {
    Screen: dynamic(() => import('./ProcessingNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./ProcessingNatalChart'),
  },
  [ScreenType.PROBLEM]: {
    Screen: dynamic(() => import('./Problem').then((mod) => mod.default)),
    importChunk: () => import('./Problem'),
  },
  [ScreenType.COMPOUNDED_TITLE_INFORMATIONAL]: {
    Screen: dynamic(() => import('./CompoundedTitleInformational').then((mod) => mod.default)),
    importChunk: () => import('./CompoundedTitleInformational'),
  },
  [ScreenType.REVIEW]: {
    Screen: dynamic(() => import('./Review').then((mod) => mod.default)),
    importChunk: () => import('./Review'),
  },
  [ScreenType.PROCESSING_LOADER]: {
    Screen: dynamic(() => import('./ProcessingLoader').then((mod) => mod.default)),
    importChunk: () => import('./ProcessingLoader'),
  },
  [ScreenType.EMAIL]: {
    Screen: dynamic(() => import('./Email').then((mod) => mod.default)),
    importChunk: () => import('./Email'),
  },
  [ScreenType.EMAIL_PALMISTRY]: {
    Screen: dynamic(() => import('./EmailPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./EmailPalmistry'),
  },
  [ScreenType.EMAIL_NATAL_CHART]: {
    Screen: dynamic(() => import('./EmailNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./EmailNatalChart'),
  },
  [ScreenType.EMAIL_CONFIRM]: {
    Screen: dynamic(() => import('./EmailConfirm').then((mod) => mod.default)),
    importChunk: () => import('./EmailConfirm'),
  },
  [ScreenType.EMAIL_CONFIRM_PALMISTRY]: {
    Screen: dynamic(() => import('./EmailConfirmPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./EmailConfirmPalmistry'),
  },
  [ScreenType.EMAIL_CONFIRM_NATAL_CHART]: {
    Screen: dynamic(() => import('./EmailConfirmNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./EmailConfirmNatalChart'),
  },
  [ScreenType.ONBOARDING]: {
    Screen: dynamic(() => import('./Onboarding').then((mod) => mod.default)),
    importChunk: () => import('./Onboarding'),
  },
  [ScreenType.ONBOARDING_PALMISTRY]: {
    Screen: dynamic(() => import('./OnboardingPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./OnboardingPalmistry'),
  },
  [ScreenType.SCAN_PREVIEW]: {
    Screen: dynamic(() => import('./ScanPreview').then((mod) => mod.ScanPreview)),
    importChunk: () => import('./ScanPreview'),
  },
  [ScreenType.SCAN_PREVIEW_V2]: {
    Screen: dynamic(() => import('./ScanPreview').then((mod) => mod.ScanPreviewV2)),
    importChunk: () => import('./ScanPreview'),
  },
  [ScreenType.SCAN]: {
    Screen: dynamic(() => import('./Scan').then((mod) => mod.Scan)),
    importChunk: () => import('./Scan'),
  },
  [ScreenType.SCAN_WITH_SKIP_ERROR]: {
    Screen: dynamic(() => import('./Scan').then((mod) => mod.ScanWithScreenError)),
    importChunk: () => import('./Scan'),
  },
  [ScreenType.SCAN_WITH_PREVIEW]: {
    Screen: dynamic(() => import('./Scan').then((mod) => mod.ScanWithPreview)),
    importChunk: () => import('./Scan'),
  },
  [ScreenType.SCAN_V2]: {
    Screen: dynamic(() => import('./ScanV2').then((mod) => mod.default)),
    importChunk: () => import('./ScanV2'),
  },
  [ScreenType.SCAN_ANALYSING]: {
    Screen: dynamic(() => import('./ScanAnalysing').then((mod) => mod.default)),
    importChunk: () => import('./ScanAnalysing'),
  },
  [ScreenType.SCAN_ANALYSING_V2]: {
    Screen: dynamic(() => import('./ScanAnalysingV2').then((mod) => mod.default)),
    importChunk: () => import('./ScanAnalysingV2'),
  },
  [ScreenType.REPORT]: {
    Screen: dynamic(() => import('./Report').then((mod) => mod.default)),
    importChunk: () => import('./Report'),
  },
  [ScreenType.SCAN_ANALYSING_COMPLETED]: {
    Screen: dynamic(() => import('./ScanAnalysingCompleted').then((mod) => mod.default)),
    importChunk: () => import('./ScanAnalysingCompleted'),
  },
  [ScreenType.SINGLE_ZODIAC_INFO]: {
    Screen: dynamic(() => import('./SingleZodiacInfo').then((mod) => mod.default)),
    importChunk: () => import('./SingleZodiacInfo'),
  },
  [ScreenType.RELATIONSHIP_ZODIAC_INFO]: {
    Screen: dynamic(() => import('./RelationshipZodiacInfo').then((mod) => mod.default)),
    importChunk: () => import('./RelationshipZodiacInfo'),
  },
  [ScreenType.LIMITED_CHOICE]: {
    Screen: dynamic(() => import('./LimitedChoice').then((mod) => mod.default)),
    importChunk: () => import('./LimitedChoice'),
  },
  [ScreenType.MENTIONED_IN]: {
    Screen: dynamic(() => import('./MentionedIn').then((mod) => mod.default)),
    importChunk: () => import('./MentionedIn'),
  },
  [ScreenType.TRIAL_CHOICE]: {
    Screen: dynamic(() => import('./TrialChoice').then((mod) => mod.default)),
    importChunk: () => import('./TrialChoice'),
  },
  [ScreenType.TRIAL_CHOICE_NATAL_CHART]: {
    Screen: dynamic(() => import('./TrialChoiceNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./TrialChoiceNatalChart'),
  },
  [ScreenType.TRIAL_CHOICE_PALMISTRY_V2]: {
    Screen: dynamic(() => import('./TrialChoicePalmistryV2').then((mod) => mod.default)),
    importChunk: () => import('./TrialChoicePalmistryV2'),
  },
  [ScreenType.TRIAL_PAYMENT]: {
    Screen: dynamic(() => import('./TrialPayment').then((mod) => mod.default)),
    importChunk: () => import('./TrialPayment'),
  },
  [ScreenType.TRIAL_PAYMENT_V2]: {
    Screen: dynamic(() => import('./TrialPaymentV2').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentV2'),
  },
  [ScreenType.TRIAL_PAYMENT_NATAL_CHART]: {
    Screen: dynamic(() =>
      import('./TrialPaymentNatalChart').then((mod) => mod.TrialPaymentNatalChartV1),
    ),
    importChunk: () => import('./TrialPaymentNatalChart'),
  },
  [ScreenType.TRIAL_PAYMENT_NATAL_CHART_V3]: {
    Screen: dynamic(() => import('./TrialPaymentNatalChartV3').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentNatalChartV3'),
  },
  [ScreenType.TRIAL_PAYMENT_NATAL_CHART_V4]: {
    Screen: dynamic(() =>
      import('./TrialPaymentNatalChart').then((mod) => mod.TrialPaymentNatalChartV4),
    ),
    importChunk: () => import('./TrialPaymentNatalChart'),
  },
  [ScreenType.TRIAL_PAYMENT_WITCH_POWER]: {
    Screen: dynamic(() => import('./TrialPaymentWitchPower').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentWitchPower'),
  },
  [ScreenType.TRIAL_PAYMENT_WITCH_POWER_V2]: {
    Screen: dynamic(() => import('./TrialPaymentWitchPowerV2').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentWitchPowerV2'),
  },
  [ScreenType.TRIAL_PAYMENT_PALMISTRY_V2]: {
    Screen: dynamic(() => import('./TrialPaymentPalmistryV2').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentPalmistryV2'),
  },
  [ScreenType.TRIAL_PAYMENT_PALMISTRY_V3]: {
    Screen: dynamic(() => import('./TrialPaymentPalmistryV3').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentPalmistryV3'),
  },
  [ScreenType.TRIAL_PAYMENT_INTRO_OFFER_V2]: {
    Screen: dynamic(() => import('./TrialPaymentIntroOfferV2').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentIntroOfferV2'),
  },
  [ScreenType.ADDITIONAL_DISCOUNT]: {
    Screen: dynamic(() => import('./AdditionalDiscount').then((mod) => mod.AdditionalDiscount)),
    importChunk: () => import('./AdditionalDiscount'),
  },
  [ScreenType.ADDITIONAL_DISCOUNT_V2]: {
    Screen: dynamic(() => import('./AdditionalDiscount').then((mod) => mod.AdditionalDiscountV2)),
    importChunk: () => import('./AdditionalDiscount'),
  },
  [ScreenType.ADDITIONAL_DISCOUNT_PALMISTRY]: {
    Screen: dynamic(() => import('./AdditionalDiscountPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./AdditionalDiscountPalmistry'),
  },
  [ScreenType.ADDITIONAL_DISCOUNT_PALMISTRY_V2]: {
    Screen: dynamic(() => import('./AdditionalDiscountPalmistryV2').then((mod) => mod.default)),
    importChunk: () => import('./AdditionalDiscountPalmistryV2'),
  },
  [ScreenType.TRIAL_PAYMENT_WITH_DISCOUNT]: {
    Screen: dynamic(() => import('./TrialPaymentWithDiscount').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentWithDiscount'),
  },
  [ScreenType.TRIAL_PAYMENT_WITH_DISCOUNT_PALMISTRY_V2]: {
    Screen: dynamic(() =>
      import('./TrialPaymentWithDiscountPalmistryV2').then((mod) => mod.default),
    ),
    importChunk: () => import('./TrialPaymentWithDiscountPalmistryV2'),
  },
  [ScreenType.UPSELLS]: {
    Screen: dynamic(() => import('./Upsells').then((mod) => mod.Upsells)),
    importChunk: () => import('./Upsells'),
  },
  [ScreenType.UPSELLS_WITH_CONTENT]: {
    Screen: dynamic(() => import('./Upsells').then((mod) => mod.UpsellsWithContent)),
    importChunk: () => import('./Upsells'),
  },
  [ScreenType.UPSELLS_NATAL_CHART]: {
    Screen: dynamic(() => import('./UpsellsNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./UpsellsNatalChart'),
  },
  [ScreenType.UPSELLS_PALMISTRY_V2]: {
    Screen: dynamic(() => import('./UpsellsPalmistryV2').then((mod) => mod.default)),
    importChunk: () => import('./UpsellsPalmistryV2'),
  },
  [ScreenType.UPSELLS_EMAIL_MARKETING]: {
    Screen: dynamic(() => import('./UpsellsEmailMarketing').then((mod) => mod.default)),
    importChunk: () => import('./UpsellsEmailMarketing'),
  },
  [ScreenType.UNLIMITED_READINGS]: {
    Screen: dynamic(() => import('./UnlimitedReadings').then((mod) => mod.default)),
    importChunk: () => import('./UnlimitedReadings'),
  },
  [ScreenType.TRIAL_CREDITS]: {
    Screen: dynamic(() => import('./TrialCredits').then((mod) => mod.TrialCredits)),
    importChunk: () => import('./TrialCredits'),
  },
  [ScreenType.TRIAL_CREDITS_WITH_CONTENT]: {
    Screen: dynamic(() => import('./TrialCredits').then((mod) => mod.TrialCreditsWithContent)),
    importChunk: () => import('./TrialCredits'),
  },
  [ScreenType.TRIAL_CREDITS_NATAL_CHART]: {
    Screen: dynamic(() => import('./TrialCreditsNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./TrialCreditsNatalChart'),
  },
  [ScreenType.TRIAL_CREDITS_PALMISTRY]: {
    Screen: dynamic(() => import('./TrialCreditsPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./TrialCreditsPalmistry'),
  },
  [ScreenType.TRIAL_CREDITS_PALMISTRY_V2]: {
    Screen: dynamic(() => import('./TrialCreditsPalmistryV2').then((mod) => mod.default)),
    importChunk: () => import('./TrialCreditsPalmistryV2'),
  },
  [ScreenType.TRIAL_CREDITS_EMAIL_MARKETING]: {
    Screen: dynamic(() => import('./TrialCreditsEmailMarketing').then((mod) => mod.default)),
    importChunk: () => import('./TrialCreditsEmailMarketing'),
  },
  [ScreenType.ONBOARDING_ASK]: {
    Screen: dynamic(() => import('./OnboardingAsk').then((mod) => mod.default)),
    importChunk: () => import('./OnboardingAsk'),
  },
  [ScreenType.ONBOARDING_ASK_V2]: {
    Screen: dynamic(() => import('./OnboardingAskV2').then((mod) => mod.default)),
    importChunk: () => import('./OnboardingAskV2'),
  },
  [ScreenType.ONBOARDING_ASK_NATAL_CHART]: {
    Screen: dynamic(() => import('./OnboardingAskNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./OnboardingAskNatalChart'),
  },
  [ScreenType.ONBOARDING_ASK_PALMISTRY]: {
    Screen: dynamic(() => import('./OnboardingAskPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./OnboardingAskPalmistry'),
  },
  [ScreenType.TALK_WITH_EXPERT]: {
    Screen: dynamic(() => import('./TalkWithExpert').then((mod) => mod.default)),
    importChunk: () => import('./TalkWithExpert'),
  },
  [ScreenType.TALK_WITH_EXPERT_NATAL_CHART]: {
    Screen: dynamic(() => import('./TalkWithExpertNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./TalkWithExpertNatalChart'),
  },
  [ScreenType.TALK_WITH_EXPERT_PALMISTRY]: {
    Screen: dynamic(() => import('./TalkWithExpertPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./TalkWithExpertPalmistry'),
  },
  [ScreenType.QUESTIONS]: {
    Screen: dynamic(() => import('./Questions').then((mod) => mod.default)),
    importChunk: () => import('./Questions'),
  },
  [ScreenType.QUESTIONS_NATAL_CHART]: {
    Screen: dynamic(() => import('./QuestionsNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./QuestionsNatalChart'),
  },
  [ScreenType.QUESTIONS_PALMISTRY]: {
    Screen: dynamic(() => import('./QuestionsPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./QuestionsPalmistry'),
  },
  [ScreenType.CREDITS]: {
    Screen: dynamic(() => import('./Credits').then((mod) => mod.default)),
    importChunk: () => import('./Credits'),
  },
  [ScreenType.CREDITS_NATAL_CHART]: {
    Screen: dynamic(() => import('./CreditsNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./CreditsNatalChart'),
  },
  [ScreenType.LOADING_ASK]: {
    Screen: dynamic(() => import('./LoadingAsk').then((mod) => mod.default)),
    importChunk: () => import('./LoadingAsk'),
  },
  [ScreenType.LOADING_ASK_NATAL_CHART]: {
    Screen: dynamic(() => import('./LoadingAskNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./LoadingAskNatalChart'),
  },
  [ScreenType.LOADING_ASK_PALMISTRY]: {
    Screen: dynamic(() => import('./LoadingAskPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./LoadingAskPalmistry'),
  },
  [ScreenType.PHONE_NUMBER]: {
    Screen: dynamic(() => import('./PhoneNumber').then((mod) => mod.default)),
    importChunk: () => import('./PhoneNumber'),
  },
  [ScreenType.PHONE_NUMBER_PALMISTRY]: {
    Screen: dynamic(() => import('./PhoneNumberPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./PhoneNumberPalmistry'),
  },
  [ScreenType.PHONE_NUMBER_EMAIL_MARKETING]: {
    Screen: dynamic(() => import('./PhoneNumberEmailMarketing').then((mod) => mod.default)),
    importChunk: () => import('./PhoneNumberEmailMarketing'),
  },
  [ScreenType.WHICH_FIGURE]: {
    Screen: dynamic(() => import('./WhichFigure').then((mod) => mod.default)),
    importChunk: () => import('./WhichFigure'),
  },
  [ScreenType.MOON_PHASE]: {
    Screen: dynamic(() => import('./MoonPhase').then((mod) => mod.default)),
    importChunk: () => import('./MoonPhase'),
  },
  [ScreenType.PARTNER_MOON_PHASE]: {
    Screen: dynamic(() => import('./PartnerMoonPhase').then((mod) => mod.default)),
    importChunk: () => import('./PartnerMoonPhase'),
  },
  [ScreenType.THANK_YOU]: {
    Screen: dynamic(() => import('./ThankYou').then((mod) => mod.default)),
    importChunk: () => import('./ThankYou'),
  },
  [ScreenType.THANK_YOU_WITH_REDIRECT]: {
    Screen: dynamic(() => import('./ThankYouWithRedirect').then((mod) => mod.default)),
    importChunk: () => import('./ThankYouWithRedirect'),
  },
  [ScreenType.NAME_MOON_COMPATIBILITY]: {
    Screen: dynamic(() => import('./NameMoonCompatibility').then((mod) => mod.default)),
    importChunk: () => import('./NameMoonCompatibility'),
  },
  [ScreenType.NAME_MOON_COMPATIBILITY_V2]: {
    Screen: dynamic(() => import('./NameMoonCompatibilityV2').then((mod) => mod.default)),
    importChunk: () => import('./NameMoonCompatibilityV2'),
  },
  [ScreenType.TRIAL_PAYMENT_MOON_COMPATIBILITY]: {
    Screen: dynamic(() => import('./TrialPaymentMoonCompatibility').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentMoonCompatibility'),
  },
  [ScreenType.LOADING_MOON_COMPATIBILITY]: {
    Screen: dynamic(() => import('./LoadingMoonCompatibility').then((mod) => mod.default)),
    importChunk: () => import('./LoadingMoonCompatibility'),
  },
  [ScreenType.HELLO_MOON_COMPATIBILITY]: {
    Screen: dynamic(() => import('./HelloMoonCompatibility').then((mod) => mod.default)),
    importChunk: () => import('./HelloMoonCompatibility'),
  },
  [ScreenType.EMAIL_BLURRED]: {
    Screen: dynamic(() => import('./EmailBlurred').then((mod) => mod.default)),
    importChunk: () => import('./EmailBlurred'),
  },
  [ScreenType.TRIAL_PAYMENT_HUMAN_DESIGN]: {
    Screen: dynamic(() => import('./TrialPaymentHumanDesign').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentHumanDesign'),
  },
  [ScreenType.USER_TYPE_HUMAN_DESIGN]: {
    Screen: dynamic(() => import('./UserTypeHumanDesign').then((mod) => mod.default)),
    importChunk: () => import('./UserTypeHumanDesign'),
  },
  [ScreenType.PLACE_HUMAN_DESIGN]: {
    Screen: dynamic(() => import('./PlaceHumanDesign').then((mod) => mod.default)),
    importChunk: () => import('./PlaceHumanDesign'),
  },
  [ScreenType.EMAIL_MARKETING_WITCH_POWER]: {
    Screen: dynamic(() => import('./EmailMarketingWitchPower').then((mod) => mod.default)),
    importChunk: () => import('./EmailMarketingWitchPower'),
  },
  [ScreenType.EMAIL_MARKETING_NATAL_CHART]: {
    Screen: dynamic(() => import('./EmailMarketingNatalChart').then((mod) => mod.default)),
    importChunk: () => import('./EmailMarketingNatalChart'),
  },
  [ScreenType.EMAIL_MARKETING_PALMISTRY]: {
    Screen: dynamic(() => import('./EmailMarketingPalmistry').then((mod) => mod.default)),
    importChunk: () => import('./EmailMarketingPalmistry'),
  },
  [ScreenType.EMAIL_MARKETING_COMPATIBILITY]: {
    Screen: dynamic(() => import('./EmailMarketingCompatibility').then((mod) => mod.default)),
    importChunk: () => import('./EmailMarketingCompatibility'),
  },
  [ScreenType.EMAIL_MARKETING_COMPATIBILITY_ONE_TIME_PAYMENT]: {
    Screen: dynamic(() =>
      import('./EmailMarketingCompatibilityOneTimePayment').then((mod) => mod.default),
    ),
    importChunk: () => import('./EmailMarketingCompatibilityOneTimePayment'),
  },
  [ScreenType.NAME_HUMAN_DESIGN]: {
    Screen: dynamic(() => import('./NameHumanDesign').then((mod) => mod.default)),
    importChunk: () => import('./NameHumanDesign'),
  },
  [ScreenType.SPLIT]: {
    Screen: dynamic(() => import('./Split').then((mod) => mod.default)),
    importChunk: () => import('./Split'),
  },
  [ScreenType.RELATIONSHIP_PROGRESS]: {
    Screen: dynamic(() => import('./RelationshipProgress').then((mod) => mod.default)),
    importChunk: () => import('./RelationshipProgress'),
  },
  [ScreenType.TRIAL_PAYMENT_ATTACHMENT_STYLE]: {
    Screen: dynamic(() => import('./TrialPaymentAttachmentStyle').then((mod) => mod.default)),
    importChunk: () => import('./TrialPaymentAttachmentStyle'),
  },
  [ScreenType.GENDER_V2]: {
    Screen: dynamic(() => import('./GenderV2').then((mod) => mod.default)),
    importChunk: () => import('./GenderV2'),
  },
  [ScreenType.TRIAL_PAYMENT_ATTACHMENT_STYLE_WITH_DISCOUNT]: {
    Screen: dynamic(() =>
      import('./TrialPaymentAttachmentStyleWithDiscount').then((mod) => mod.default),
    ),
    importChunk: () => import('./TrialPaymentAttachmentStyleWithDiscount'),
  },
  [ScreenType.TRIAL_PAYMENT_ATTACHMENT_STYLE_WITH_DISCOUNT_V3]: {
    Screen: dynamic(() =>
      import('./TrialPaymentAttachmentStyleWithDiscountV3').then(
        (mod) => mod.TrialPaymentAttachmentStyleWithDiscountV3,
      ),
    ),
    importChunk: () => import('./TrialPaymentAttachmentStyleWithDiscountV3'),
  },
  [ScreenType.TRIAL_PAYMENT_WITH_DISCOUNT_PALMISTRY_V3]: {
    Screen: dynamic(() =>
      import('./TrialPaymentWithDiscountPalmistryV3').then((mod) => mod.default),
    ),
    importChunk: () => import('./TrialPaymentWithDiscountPalmistryV3'),
  },
  [ScreenType.INFORMATIONAL_V2]: {
    Screen: dynamic(() => import('./InformationalV2').then((mod) => mod.default)),
    importChunk: () => import('./InformationalV2'),
  },
  [ScreenType.INFORMATIONAL_DYNAMIC]: {
    Screen: dynamic(() => import('./InformationalDynamic').then((mod) => mod.InformationalDynamic)),
    importChunk: () => import('./InformationalDynamic'),
  },
  [ScreenType.SOCIAL_PROOF]: {
    Screen: dynamic(() => import('./SocialProof').then((mod) => mod.default)),
    importChunk: () => import('./SocialProof'),
  },
  [ScreenType.ANSWER_IMAGE]: {
    Screen: dynamic(() => import('./AnswerImage').then((mod) => mod.default)),
    importChunk: () => import('./AnswerImage'),
  },
  [ScreenType.ANSWER_IMAGE_MULTIPLE]: {
    Screen: dynamic(() => import('./AnswerImageMultiple').then((mod) => mod.default)),
    importChunk: () => import('./AnswerImageMultiple'),
  },
  [ScreenType.UPSELL_INFO]: {
    Screen: dynamic(() => import('./UpsellInfo').then((mod) => mod.default)),
    importChunk: () => import('./UpsellInfo'),
  },
  [ScreenType.UPSELL_CONSULTATION]: {
    Screen: dynamic(() => import('./UpsellConsultation').then((mod) => mod.default)),
    importChunk: () => import('./UpsellConsultation'),
  },
  [ScreenType.UPSELL_CONSULTATION_WITH_DISCOUNT]: {
    Screen: dynamic(() => import('./UpsellConsultationWithDiscount').then((mod) => mod.default)),
    importChunk: () => import('./UpsellConsultationWithDiscount'),
  },
  [ScreenType.UPSELL_READINGS_PACK]: {
    Screen: dynamic(() => import('./UpsellReadingsPack').then((mod) => mod.default)),
    importChunk: () => import('./UpsellReadingsPack'),
  },
  [ScreenType.UPSELL_READINGS_PACK_WITH_DISCOUNT]: {
    Screen: dynamic(() => import('./UpsellReadingsPackWithDiscount').then((mod) => mod.default)),
    importChunk: () => import('./UpsellReadingsPackWithDiscount'),
  },
  [ScreenType.UPSELLS_V3]: {
    Screen: dynamic(() => import('./UpsellsV3').then((mod) => mod.default)),
    importChunk: () => import('./UpsellsV3'),
  },
  [ScreenType.SUMMARY]: {
    Screen: dynamic(() => import('./Summary').then((mod) => mod.default)),
    importChunk: () => import('./Summary'),
  },
  [ScreenType.SUMMARY_V2]: {
    Screen: dynamic(() => import('./SummaryV2').then((mod) => mod.default)),
    importChunk: () => import('./SummaryV2'),
  },
  [ScreenType.TIMELINE]: {
    Screen: dynamic(() => import('./Timeline').then((mod) => mod.default)),
    importChunk: () => import('./Timeline'),
  },
  [ScreenType.LOADER_WITH_REVIEWS]: {
    Screen: dynamic(() => import('./LoaderWithReviews').then((mod) => mod.default)),
    importChunk: () => import('./LoaderWithReviews'),
  },
  [ScreenType.EMAIL_MARKETING_PAYWALL]: {
    Screen: dynamic(() => import('./EmailMarketingPaywall').then((mod) => mod.default)),
    importChunk: () => import('./EmailMarketingPaywall'),
  },
  [ScreenType.TRIAL_PAYMENT_ATTACHMENT_STYLE_V3]: {
    Screen: dynamic(() =>
      import('./TrialPaymentAttachmentStyleV3').then((mod) => mod.TrialPaymentAttachmentStyleV3),
    ),
    importChunk: () => import('./TrialPaymentAttachmentStyleV3'),
  },
  [ScreenType.W2A_PROMOTION]: {
    Screen: dynamic(() => import('./W2APromotion').then((mod) => mod.default)),
    importChunk: () => import('./W2APromotion'),
  },
  [ScreenType.GENDER_V3]: {
    Screen: dynamic(() => import('./Gender').then((mod) => mod.GenderV3)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.GENDER_V4]: {
    Screen: dynamic(() => import('./Gender').then((mod) => mod.GenderV4)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.UPSELL_CONSULTATION_V2]: {
    Screen: dynamic(() => import('./UpsellConsultationV2').then((mod) => mod.default)),
    importChunk: () => import('./UpsellConsultationV2'),
  },
  [ScreenType.UPSELL_SHORT]: {
    Screen: dynamic(() => import('./UpsellShort').then((mod) => mod.default)),
    importChunk: () => import('./UpsellShort'),
  },
  [ScreenType.STORIES]: {
    Screen: dynamic(() => import('./Stories').then((mod) => mod.default)),
    importChunk: () => import('./Stories'),
  },
  [ScreenType.ECOMMERCE_PAYWALL]: {
    Screen: dynamic(() => import('./EcommercePaywall').then((mod) => mod.EcommercePaywall)),
    importChunk: () => import('./EcommercePaywall'),
  },
  [ScreenType.TRIAL_CHOICE_V2]: {
    Screen: dynamic(() => import('./TrialChoiceV2').then((mod) => mod.TrialChoiceV2)),
    importChunk: () => import('./TrialChoiceV2'),
  },
  [ScreenType.EMAIL_MARKETING]: {
    Screen: dynamic(() => import('./EmailMarketing').then((mod) => mod.EmailMarketing)),
    importChunk: () => import('./EmailMarketing'),
  },
  [ScreenType.GENDER_V5]: {
    Screen: dynamic(() => import('./Gender').then((mod) => mod.GenderV5)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.TRIAL_PAYMENT_V3]: {
    Screen: dynamic(() => import('./TrialPaymentV3').then((mod) => mod.TrialPaymentV3)),
    importChunk: () => import('./TrialPaymentV3'),
  },
  [ScreenType.PAYWALL_WITH_TRIAL_CHOICE]: {
    Screen: dynamic(() =>
      import('./PaywallWithTrialChoice').then((mod) => mod.PaywallWithTrialChoice),
    ),
    importChunk: () => import('./PaywallWithTrialChoice'),
  },
  [ScreenType.TRIAL_CHOICE_WITH_SLIDER]: {
    Screen: dynamic(() =>
      import('./TrialChoiceWithSlider').then((mod) => mod.TrialChoiceWithSlider),
    ),
    importChunk: () => import('./TrialChoiceWithSlider'),
  },
};
